import { Mutations } from 'vuex-smart-module';

import BookingState from './state';

export default class BookingMutations extends Mutations<BookingState> {}
